import React from "react";

import { styled } from "@mui/material/styles";
import { Box, Grid } from "@mui/material";

import SidebarButtonDownload from './SidebarButtonDownload'
import LoginButton from '../login/LoginButton'

declare var CookieControl;

const StyledBox = styled(Box)(() => ({
  backgroundColor: "#1b2021",
}));

function SidebarButtonBar({ padTop, onlyShowLogo=false }) {
  const viewCivicCookieSettings = (event) => {
    event.preventDefault();
    CookieControl.open()
  }

  const renderButtons = () => {
    if (onlyShowLogo) {
      return (<Grid item xs={8} />)
    }

    return (
      <>
        <Grid item xs={4} sx={{
          mt: 1
        }}>
          <SidebarButtonDownload />
        </Grid>
        <Grid item xs={4} sx={{
          mt: 1
        }}>
          <LoginButton />
        </Grid>
      </>
    )
  }

  return (
    <StyledBox sx={{
      display: "flex",
      gap: "20px",
      width: "100%",
      pt: padTop ? 2 : 0,
    }}>
      <Grid className="drawer-actions" container spacing={1}>
        {renderButtons()}
        <Grid item xs={onlyShowLogo ? 12 : 4} sx={{
          display: "flex",
          flexDirection: onlyShowLogo ? "row" : "column",
          justifyContent: onlyShowLogo ? "space-around" : "center",
          alignItems: "center",
          "& a": {
            color: "#00AEEF",
          }
        }}>
          <img
            width={140}
            alt="Mayor of London Logo"
            src="./mayoroflondon.svg"
          />
          <a target="_blank" href="https://www.london.gov.uk/who-we-are/governance-and-spending/privacy-policies">
            Privacy Policy
          </a>
          <a href="#" onClick={viewCivicCookieSettings}>
            Cookie Settings
          </a>
        </Grid>
      </Grid>
    </StyledBox>
  )
}

export default SidebarButtonBar;